import React from 'react';

import {
	EvChip,
	EvFlexRow,
	EvIconButton,
	EvLabelDefault,
	EvSwitch,
	EvTableColumn,
	EyeOff,
	Trash2
} from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_PANEL_REMOVE_VALUE_DAID } from 'data-automation-ids/LabelManagementAutomationIds';

import { LabelValue } from '../../../../../types';

import { DashboardColumnHeader } from './dashboard-column-header';
import { VALUES_TABLE_COLUMN_WIDTHS } from './ValuesTable.constants';
import { VALUES_TABLE_LABELS } from './ValuesTable.labels';

export const getValuesTableColumns = (
	showDashboardVisibility: boolean,
	onRemoveValue: (value: string) => void,
	onToggleDashboardVisibility: (value: string) => void
): EvTableColumn[] => {
	const columns: EvTableColumn[] = [
		{
			dataField: 'value',
			text: VALUES_TABLE_LABELS.COLUMN_VALUE,
			sort: true,
			style: { width: VALUES_TABLE_COLUMN_WIDTHS.VALUE },
			headerStyle: { width: VALUES_TABLE_COLUMN_WIDTHS.VALUE },
			formatter: (_cell: unknown, row: LabelValue) => {
				const { value, dashboardVisible, isSessionNew } = row;
				return (
					<EvFlexRow gap="SMALL" align="CENTER" wrap="WRAP">
						<EvChip
							id={value}
							label={value}
							icons={dashboardVisible === false ? { prefix: EyeOff } : undefined}
						/>
						{isSessionNew ? (
							<span className="trigger-badge">
								<EvLabelDefault>{VALUES_TABLE_LABELS.NEW_VALUE_BADGE}</EvLabelDefault>
							</span>
						) : null}
					</EvFlexRow>
				);
			}
		}
	];

	if (showDashboardVisibility) {
		columns.push({
			dataField: 'dashboardVisible',
			text: VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY,
			style: { width: VALUES_TABLE_COLUMN_WIDTHS.DASHBOARD_VISIBILITY },
			headerStyle: { width: VALUES_TABLE_COLUMN_WIDTHS.DASHBOARD_VISIBILITY },
			headerFormatter: () => <DashboardColumnHeader />,
			formatter: (_cell: unknown, row: LabelValue) => (
				<EvSwitch
					checked={row.dashboardVisible !== false}
					onChange={() => onToggleDashboardVisibility(row.value)}
					ariaLabel={`${VALUES_TABLE_LABELS.TOGGLE_VISIBLE_ARIA} for ${row.value}`}
				/>
			)
		});
	}

	columns.push({
		dataField: 'actions',
		text: VALUES_TABLE_LABELS.COLUMN_ACTIONS,
		srColumnText: VALUES_TABLE_LABELS.COLUMN_ACTIONS_SR,
		style: { width: VALUES_TABLE_COLUMN_WIDTHS.ACTIONS },
		headerStyle: { width: VALUES_TABLE_COLUMN_WIDTHS.ACTIONS },
		formatter: (_cell: unknown, row: LabelValue) => (
			<EvFlexRow justify="CENTER" align="CENTER">
				<EvIconButton
					icon={Trash2}
					ariaLabel={`${VALUES_TABLE_LABELS.REMOVE_BUTTON_ARIA} ${row.value}`}
					onClick={() => onRemoveValue(row.value)}
					dataAutomationId={LABEL_MANAGEMENT_PANEL_REMOVE_VALUE_DAID}
				/>
			</EvFlexRow>
		)
	});

	return columns;
};
